// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';


// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
const routes = {
  // All pages
  common,
  // Home page
  home,
};

// Load Events
jQuery(document).ready(() => new Router(routes).loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js